module.exports = __webpack_public_path__ + "media/images/doctor-congrats_2-template-8f0dcbd60590a52da8f955a4c6b4437c.jpg";